<template>
  <div id="chat-discussion" class="chat-discussion" :class="!userHasAcceptedTerms && !this.$userIsAdmin && !adminThread ? 'terms-height' : null" ref="chat_discussion">
    <div v-if="thread && thread.id">
      <div v-if="!userHasAcceptedTerms && !this.$userIsAdmin && !adminThread">
        <thread-accept-terms/>
      </div>
      <div v-else>
        <thread-discussion-message
          v-for="message in thread.messages" :key="message.id" v-bind:message="message" v-bind:readers="lastReadBy(message)"/>
      </div>
    </div>
    <div v-else>
      <pickstar-loading class="m-t-lg"/>
    </div>
  </div>
</template>
<script>
import ThreadDiscussionMessage from './ThreadDiscussionMessage'
import ThreadAcceptTerms from './ThreadAcceptTerms'
import LazyLoading from 'codium-lazy-loading'
import { findIndex, filter } from 'lodash'
import { mapState } from 'vuex'
import { helpers } from 'mixins/messages'

export default {
  mixins: [helpers],

  computed: {
    ...mapState('message', ['thread']),

    userHasAcceptedTerms () {
      if (this.thread) {
        let userIndex = findIndex(this.thread.participants, participant => participant.id === this.$user.id)
        if (userIndex !== -1) {
          return this.thread.participants[userIndex].terms_accepted
        }
      }

      return false
    },

    participants () {
      return filter(this.thread.participants, (participant) => {
        return this.$user.id !== participant.id
      })
    }
  },

  methods: {
    lastReadBy (message) {
      return filter(this.participants, (participant) => {
        return message.id === participant.message_id
      })
    }
  },

  components: {
    ThreadDiscussionMessage,
    ThreadAcceptTerms,
    LazyLoading
  },

  watch: {
    'thread.messages' () {
      this.$nextTick(function () {
        var objDiv = this.$refs.chat_discussion
        objDiv.scrollTop = objDiv.scrollHeight
      })
    }
  }
}
</script>
